<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/51geWa/tc-custom/9781504088121.jpg?1718858108246" alt="This image is the cover for the book Panic!, Department Z"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Panic!, Department Z
      </h1>
      <p class="bookDescription body article font2">
        <b>The adventure that brought two intrepid cousins into the service of the department of British intelligence known as Z . . .</b><br/><br/>Desperate to escape the suffocating heat of London, cousins Mark and Mike Errol set out for Richmond for a relaxing boat ride. Little did they know their peaceful afternoon would be violently interrupted by a Department Z mission that would completely change their lives.<br/><br/>Quickly recruited into the secret agency, the Errols embark on one of the department's most treacherous cases. The League of the Hundred-and-One are terrorizing the people of Britain and holding the country ransom. With one hundred and one reasons to panic, can Department Z defeat this elusive league before the nation crumbles?
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John Creasey
      </h2>
      
      <p class="authorDescription body article">John Creasey, born in 1908, was a paramount English crime and science fiction writer who used myriad pseudonyms for more than six hundred novels. He founded the UK Crime Writers’ Association in 1953. In 1962, his book <I>Gideon’s Fire</I> received the Edgar Award for Best Novel from the Mystery Writers of America. Many of the characters featured in Creasey’s titles became popular, including George Gideon of Scotland Yard, who was the basis for a subsequent television series and film. Creasey died in Salisbury, UK, in 1973.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Ipso Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?32e5e6ce